import { IoClose } from 'react-icons/io5';
import { NavigateFunction } from 'react-router-dom';
import './AssignForm.css';
import { useState, useEffect } from 'react';
import AssignDropdown from '../../../components/AssignDropdown/AssignDropdown';

interface Props {
  token: string;
  nav: NavigateFunction;
  handleCloseFormPressed: () => void;
  entityId: string;
  onSaveAssignedUser: () => void;
  assignableLawyers: AssignUserList[];
  assignablePhysicians: AssignUserList[];
}

interface AssignUserList {
  userId: string;
  firstName: string;
  lastName: string;
}

interface UserSelectionStateObject {
  selectableUsers: AssignUserList[];
  selectedUsers: string[];
}

function UserAssignmentForm({
  token,
  nav,
  handleCloseFormPressed,
  entityId,
  onSaveAssignedUser,
  assignableLawyers,
  assignablePhysicians
}: Props): JSX.Element {
  const [lawyers, setLawyers] = useState<UserSelectionStateObject>({
    selectableUsers: assignableLawyers,
    selectedUsers: []
  });
  const [physicians, setPhysicians] = useState<UserSelectionStateObject>({
    selectableUsers: assignablePhysicians,
    selectedUsers: []
  });
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState('');



  const handleSaveAssigned = async () => {
    if (lawyers.selectedUsers.length === 0 && physicians.selectedUsers.length === 0) {
      setError('Please select atleast one lawyer/physician');
      return;
    }

    setLoading(true);
    const allSelectedUsers = [...lawyers.selectedUsers, ...physicians.selectedUsers];
    try {
      const saveUrl = '/admin/userEntityAccess';
      const res = await fetch(saveUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          entityId: parseInt(entityId),
          assigneeIds: allSelectedUsers,
        }),
      });


      if (!res.ok) {
        setError('Failed to assign the users');
        return;
      }


      onSaveAssignedUser();
      setLoading(false);
      handleCloseFormPressed();
    } catch (error) {
      console.log('There was an error assigning users');
      console.log(error);
    }
  };

  return (
    <div className="assign-overlay">
      <div className="assign-container">
        <div className="assign-head">
          <h2>Assign</h2>
          <button
            className="new-user-close-button"
            onClick={handleCloseFormPressed}
            aria-label="Close"
          >
            <IoClose className="new-user-form-header-close" />
          </button>
        </div>

        <div className="assign-body">
          {error && <div className="error-message">{error}</div>}
          
          <AssignDropdown
            label="Assign Lawyer"
            placeholder="Select Lawyer"
            users={lawyers.selectableUsers}
            selectedUsers={lawyers.selectedUsers}
            onSelectionChange={(selectedUsers) => setLawyers(prev => ({ ...prev, selectedUsers }))}
          />

          <AssignDropdown
            label="Assign Physician"
            placeholder="Select Physician"
            users={physicians.selectableUsers}
            selectedUsers={physicians.selectedUsers}
            onSelectionChange={(selectedUsers) => setPhysicians(prev => ({ ...prev, selectedUsers }))}
          />
        </div>

        <div className="assign-save-btns assign-head">
          <button className="assign-cancel" onClick={handleCloseFormPressed}>
            CANCEL
          </button>
          <button className="assign-save" onClick={handleSaveAssigned}>
            {loading ? 'SAVING...' : 'ADD & SAVE'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserAssignmentForm;
